import React from 'react';
import { convertToNumber, getPercent } from 'dashboard/utils';
import { COLORS } from 'common/consts';
import { BaseTiles } from './BaseTiles';
import {
  StatCardWrapper,
  StatCardData,
  StatCardTooltip,
  StatCardRate,
} from './StatCard';

export const DetectTiles: React.FC = () => (
  <BaseTiles
    restPart={(stats) => (
      <>
        <StatCardWrapper contentColor="white" backgroundColor={COLORS.blue}>
          <StatCardTooltip tooltipDescription="The relation of detect to inspect" />
          <StatCardData
            description="Inspect events"
            stat={convertToNumber(stats.show)}
          />
          <StatCardData
            description="Detect events"
            stat={convertToNumber(stats.detect)}
            size="small"
          />
          <StatCardRate
            rateStatistic={getPercent(
              convertToNumber(stats.detect),
              convertToNumber(stats.show)
            )}
          />
        </StatCardWrapper>
        <StatCardWrapper backgroundColor={COLORS.green}>
          <StatCardTooltip tooltipDescription="The relation of inspects to shows slider" />
          <StatCardData
            description="Show events"
            stat={convertToNumber(stats.showSlider)}
          />
          <StatCardData
            description="Inspect events"
            stat={convertToNumber(stats.show)}
            size="small"
          />
          <StatCardRate
            rateStatistic={getPercent(
              convertToNumber(stats.showSlider),
              convertToNumber(stats.show)
            )}
          />
        </StatCardWrapper>
        <StatCardWrapper backgroundColor={COLORS.orange}>
          <StatCardTooltip tooltipDescription="The relation of inspects to closes slider" />
          <StatCardData
            description="Close events"
            stat={convertToNumber(stats.closeSlider)}
          />
          <StatCardData
            description="Inspect events"
            stat={convertToNumber(stats.show)}
            size="small"
          />
          <StatCardRate
            rateStatistic={getPercent(
              convertToNumber(stats.closeSlider),
              convertToNumber(stats.show)
            )}
          />
        </StatCardWrapper>
        <StatCardWrapper backgroundColor={COLORS.yellow}>
          <StatCardTooltip tooltipDescription="The relation of shows slider to closes slider" />
          <StatCardData
            description="Show events"
            stat={convertToNumber(stats.showSlider)}
          />
          <StatCardData
            description="Close events"
            stat={convertToNumber(stats.closeSlider)}
            size="small"
          />
          <StatCardRate
            rateStatistic={getPercent(
              convertToNumber(stats.closeSlider),
              convertToNumber(stats.showSlider)
            )}
          />
        </StatCardWrapper>
      </>
    )}
  />
);
